import React from 'react';
import { ThreeDots } from 'react-loader-spinner'
import { Link } from "react-router-dom";
import { ip } from '../../../config.js'
import SpinLoader from '../../Miscel/SpinLoader.js';

const EventsListRows = ({ rows, refresh,reload }) => {

    function dateReducer(s) {
        if (s == null) return null;
        var res = s.includes("T") ? s.split("T")[0] : s;
        res = res.split("-").reverse().join("-");
        return res;
    }

    function deleteEvent(eventId) {
        refresh("blankScreen")        
        fetch(ip + "/events/" + eventId + "?eventId=" + eventId, {
            method: 'DELETE',
            headers: { 'Authorization': 'Basic ' + localStorage.getItem('sessionKey') }
        }).then((resp) => {
            refresh(new Date());
            reload(new Date());
            return resp.json()
        }).then((resp) => {   
            console.log(resp)         
        });

    }

    return (
        <React.Fragment>

            {
                rows.map((event, idx) => {
                    
                    return (
                        <tr key={event.id}>
                            <th scope="row">{event.id}</th>
                            <td>{event.eventPurpose}</td>
                            <td>{event.conductedBy}</td>
                            <td>{dateReducer(event.eventStartDate)}</td>
                            <td>{dateReducer(event.eventEndDate)}</td>
                            <td>
                                <Link to={"/event/" + event.id}><button className="btn btn-primary">Open</button></Link>
                                {
                                    localStorage.getItem("type") === "ADMIN" &&
                                    <button className="btn event-dlt btn-danger" onClick={() => deleteEvent(event.id)}><i className="fa fa-trash" aria-hidden="true"></i></button>
                                }
                            </td>
                        </tr>
                    )
                })


            }
        </React.Fragment>
    );
}

export default EventsListRows;